<template>
    <div class="step row no-padding">
        <div class="offset-md-2 col-md-8">
            <div class="form-group text-center">
                <input id="place" name="place" placeholder="Adresa nebo souřadnice ve tvaru 50.1000593, 13.4360036" v-model="place">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Place",

        data: function() {
            return {
                place: null
            }
        },

        computed: {
            required: function () {
                return this.place != null && this.place.trim() !== '';
            }
        },
    }
</script>

<style scoped>
    .form-group input {
        width: 100%;
        text-align: left !important;
    }

    .form-group input::placeholder {
        color: lightgray;
    }
</style>
